<template>
  <div :class="[style['bottom-panel'], style['panel-option']]">
    <option-picker
      :selected-option-id="selectedOption && selectedOption.id"
      :option-list="optionList"
      :update-selected-option="updateSelectedOption"
    />
    <panel-control :close-only="true" />
  </div>
</template>

<script>
import OptionPicker from '../Components/OptionPicker.vue'
import PanelControl from '../Components/PanelControl.vue'
import style from '../scss/_bottompanel.scss'
import { Chat } from 'src/apis'
import { useBottomPanelStore } from 'Store/bottom-panel'
import { mapState } from 'pinia'
import { useChatStore } from 'Store/chat'
import { useFormStore } from 'Store/form'

export default {
  name: 'OptionPickerPanel',

  components: {
    OptionPicker,
    PanelControl
  },

  setup() {
    return {
      bottomPanelStore: useBottomPanelStore(),
      formStore: useFormStore()
    }
  },

  data() {
    return {
      style
    }
  },
  computed: {
    ...mapState(useFormStore, {
      activeForm: 'currentActiveForm',
      activeField: 'activeField',
      rentalCarForm: 'rentalCarForm'
    }),

    ...mapState(useChatStore, {
      chatID: 'chatId'
    }),

    optionList() {
      return this.bottomPanelStore[this.bottomPanelStore.displayList]
    },

    selectedOption() {
      return this.activeForm[this.activeField]
    },

    pickupTime() {
      return this.rentalCarForm.pickupTime
    }
  },
  methods: {
    updateSelectedOption(option) {
      if (this.selectedOption.id !== option.id) {
        this.formStore.setFormFieldValue(option)
        switch (this.activeField) {
          case 'pickupArea':
            this.formStore.resetOtherFormFields([
              'pickupShop',
              'pickupTime',
              'returnArea',
              'returnShop',
              'returnTime'
            ])
            Chat.getRentalCarShops(this.chatID, option.id).then(({ data: { shops } }) => {
              this.bottomPanelStore.setPickupShops(shops)
            })
            break
          case 'pickupShop':
            this.formStore.resetOtherFormFields(['pickupTime', 'returnTime'])
            this.formStore.syncPickupReturn()
            Chat.getRentalCarTimeList(option.id).then(
              ({ data: { shops, prefectures, ...restData } }) => {
                this.bottomPanelStore.setReturnPrefectures(prefectures)
                this.bottomPanelStore.setReturnShops(shops)
                this.bottomPanelStore.setPickupTimeInfo(restData)
                this.bottomPanelStore.setReturnTimeInfo(restData)
              }
            )
            break
          case 'returnArea':
            this.formStore.resetOtherFormFields(['returnShop', 'returnTime'])
            Chat.getRentalCarShops(this.chatID, option.id).then(({ data: { shops } }) => {
              this.bottomPanelStore.setReturnShops(shops)
            })
            break
          case 'returnShop':
            this.formStore.resetOtherFormFields(['returnTime'])
            Chat.getRentalCarTimeList(option.id, this.pickupTime).then(
              ({ data: { shops, prefectures, ...restData } }) => {
                this.bottomPanelStore.setReturnTimeInfo(restData)
              }
            )
            break
          default:
        }
      }
      this.bottomPanelStore.setBottomPanelComponent()
    }
  }
}
</script>
